<template>
  <div>
    <app-cells>
      <app-input
        @input.native="onClientsSearch"
        v-model="search"
        class="input--300"
        type="search"
        placeholder="Search by name"
        name="search"
      />
      <app-checkbox
        v-if="is_sales && groupDetail.type.code === 'join'"
        v-model="filter_clients"
        @change="onChangeFilter"
        label="My clients"
      />
    </app-cells>
    <v-client-table
      :data="table.items"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{ 'table-default--loading': table_clients_loading }"
    >
      <template #h__select>
        <label v-if="table.items.length" class="checkbox checkbox--table">
          <input
            v-model="checked_all"
            type="checkbox"
            name="checked_all"
          />
          <span class="checkbox__checkmark"></span>
        </label>
      </template>
      <template #h__reach_point>
        <div class="table-default__left">Reach point</div>
      </template>
      <template #h__full_name>
        <div class="table-default__left">Full name</div>
      </template>
      <template #h__group>
        <div class="table-default__left">Group</div>
      </template>
      <template #count="{ row, index }">{{ index }}</template>
      <template #select="{ row }">
        <label class="checkbox  checkbox--table">
          <input
            v-model="checked"
            type="checkbox"
            :value="row.id"
          />
          <span class="checkbox__checkmark"></span>
        </label>
      </template>
      <template #full_name="{ row }">
        <div class="table-default__left table-default__left--photo">
          <span
            :class="`fflag ff-md fflag-${row.client.citizenship ? row.client.citizenship.code : 'empty'}`"
            v-tooltip="{ content: row.client.citizenship ? row.client.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
          ></span>
          <template v-if="row.client.gender">
            <img v-if="row.client.gender.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
            <img v-if="row.client.gender.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
          </template>
          <img v-else src="@/assets/img/gender-plug-icon.svg" alt="">
          <router-link
            v-if="is_general_manager || is_sales_manager || is_sales_supervisor || is_operations_manager || is_operations_supervisor"
            :to="{ name: 'clients-detail', params: { id: row.client.id } }"
            class="table-default__link-border"
          >
            {{ row.client.full_name }}
          </router-link>
          <span v-else>{{ row.client.full_name }}</span>
          <span v-if="row.age">({{ row.age }} y.o.)</span>
          <img v-if="row.client.category && row.client.category.code === 'tour_leader'" src="@/assets/img/tour-leader-icon.svg" alt="Leader">
          <img v-if="row.birthday" src="@/assets/img/birthday-icon.svg" alt="Birthday">
        </div>
      </template>
      <template #reach_point="{ row }">
        <div class="table-default__left">
          <app-option-picker
              v-model="row.reach_point"
              :options="groupDetail.route.reach_points_available"
              @click="onOptionSelected(row)"
          />
        </div>
      </template>
      <template #group="{ row }">
        <div class="table-default__controls table-default__left">
          <div class="table-default__photo">
            <img
              :src="getUserAvatar(row.client.manager.crop.crop_url)" alt=""
              v-tooltip="{ content: row.client.manager.full_name, placement: 'top-start', offset: 10 }"
            >
          </div>
          <template v-if="row.client.group">
            <router-link
              v-if="is_general_manager || is_sales_manager || is_sales_supervisor || is_operations_manager || is_operations_supervisor"
              :to="{ name: 'clients-groups-general', params: { id: row.client.group.id } }"
              class="table-default__link-border"
            >
              {{ row.client.group.name }}
            </router-link>
            <div v-else class="table-default__left">{{ row.client.group.name }}</div>
          </template>
          <div v-else class="table-default__left">-</div>
        </div>
      </template>
      <template #additional_services_orders.tent="{ row }">
        <template v-if="row.additional_services_orders.tent">
          <span
              class="status-tag"
              :style="{ backgroundColor: row.additional_services_orders.tent.service && row.additional_services_orders.tent.service.code === 'private_tent' ? '#77b017' : row.additional_services_orders.tent.service && row.additional_services_orders.tent.service.code === 'walkin_tent' ? '#f0c427' : '#424242' }"
          >
            # {{ row.additional_services_orders.tent.number }}
          </span>
        </template>
        <template v-else>-</template>
      </template>
      <template #additional_services_orders.toilet="{ row }">
        <span v-if="row.additional_services_orders.toilet" class="status-tag" :style="{ backgroundColor: '#424242' }">
          # {{ row.additional_services_orders.toilet }}
        </span>
        <template v-else>-</template>
      </template>
      <template #additional_services_orders.shower="{ row }">
        <span v-if="row.additional_services_orders.shower" class="status-tag" :style="{ backgroundColor: '#424242' }">
          # {{ row.additional_services_orders.shower }}
        </span>
        <template v-else>-</template>
      </template>
      <template #phone="{ row }">
        <span v-if="row.additional_services_orders.phone" class="status-tag" :style="{ backgroundColor: '#424242' }">
          # {{ row.additional_services_orders.phone }}
        </span>
        <template v-else>-</template>
      </template>
      <template #porter="{ row }">
        <span v-if="row.additional_services_orders.porter" class="status-tag" :style="{ backgroundColor: '#424242' }">
          #{{ row.additional_services_orders.porter }}
        </span>
        <template v-else>-</template>
      </template>
      <template #water="{ row }">
        <span v-if="row.additional_services_orders.water" class="status-tag" :style="{ backgroundColor: '#424242' }">
          Yes
        </span>
        <template v-else>-</template>
      </template>
      <template #profile="{ row }">
        <div class="table-default__controls">
          <button
              @click="onCopyInsuranceData(row.client.climbing_insurance, 'climbing')"
              v-tooltip="{content: tooltipInsuranceContent(row.client.climbing_insurance, 'climbing'), placement: 'top-start', offset: 10, html: true}"
              class="table-default__insurance"
              :class="{ 'table-default__insurance--climbing': row.client.climbing_insurance.climbing_insurance_company }"
          ></button>
<!--          <span-->
<!--              v-if="row.climbing_insurance_is_filled"-->
<!--              class="table-default__insurance"-->
<!--              :class="{ 'table-default__insurance&#45;&#45;climbing': row.climbing_insurance_is_filled }"-->
<!--              v-tooltip="{content: tooltipContent(row.climbing_insurance), placement: 'top-start', offset: 10, html: true}"-->
<!--          ></span>-->
<!--          <span-->
<!--              v-else-->
<!--              class="table-default__insurance"-->
<!--              :class="{ 'table-default__insurance&#45;&#45;climbing': row.climbing_insurance_is_filled }"-->
<!--          ></span>-->
          <a
              :href="`${family_url}${row.client.hash}/medical`"
              target="_blank"
              class="table-default__activity table-default__activity--medical"
              :class="{'table-default__activity--active': row.client.medical_clearance}"
          ></a>
        </div>
      </template>
      <template #checklist="{ row }">
        <div class="table-default__controls">
          <button
            @click="onExport(row.id)"
            class="table-default__activity table-default__activity--checklist table-default__activity--adds"
            :class="{'table-default__activity--active': row.checklist.completed, 'table-default__activity--checklist-total': row.checklist.completed && !row.checklist.total_price}"
          ></button>
        </div>
      </template>
      <template #controls="{ row }">
        <div class="table-default__controls">
          <button @click="onDeleteButtonClick(row.client, row.id)" type="button">
            <img src="@/assets/img/delete-table-icon.svg" alt="">
          </button>
        </div>
      </template>
    </v-client-table>
    <modal
      name="delete"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete Record
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this client?</div>
          <div v-if="current_client" class="popup__info">{{ current_client.full_name }}</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete')" theme="dark">Cancel</app-button>
            <app-button @click.native="deleteClient" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="transfer-form"
      :width="500"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('transfer-form')" class="popup__close" type="button"></button>
        <div class="popup__title">Transfer clients</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckTransferForm">
            <app-cells :indent="false">
              <app-form-group label="Create new group">
                <app-switcher v-model="create_new_group" />
              </app-form-group>
              <app-form-group label="Ignore client group validation">
                <app-switcher v-model="transfer.ignore_client_group" />
              </app-form-group>
            </app-cells>
            <app-form-group v-if="!create_new_group" label="Climbing group" required>
              <app-select
                @search="onGroupSearch"
                v-model="transfer.new_group"
                :options="groups_options"
                :filterable="false"
                :clearable="false"
                :display-field="option => `${option.name} - ${option.id} (${dateFormat(option.tour_start)} - ${dateFormat(option.tour_end)})`"
                placeholder="Climbing group"
                :error="$v.transfer.new_group.$error"
              />
              <template #error>
                <div v-if="$v.transfer.new_group.$dirty && !$v.transfer.new_group.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group v-else label="Group name" label-for="group_name_climbing" required>
              <app-input
                  v-model="transfer.group_name"
                  :error="$v.transfer.group_name.$error"
                  id="group_name_climbing"
                  placeholder="Group name"
                  name="group_name_climbing"
              />
              <template #error>
                <div v-if="$v.transfer.group_name.$dirty && !$v.transfer.group_name.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.transfer.$error" type="submit" ref="submitTransfer">Complete transfer</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
      <div class="flying-block__text">Selected clients: <span>{{ checked.length }}</span></div>
      <app-button @click.native="onShowTransferModal">Transfer</app-button>
    </div>
  </div>
</template>

<script>
import {
  deleteClientClimbingGroup,
  getClimbingGroupChecklistExport,
  getClimbingGroups,
  getClimbingGroupsClients,
  patchClimbingGroupClients,
  postClientTransfer,
} from '@/http'
import { requiredIf } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'
import { format, parse } from 'date-fns'
import AppOptionPicker from '@/components/AppOptionPicker'

export default {
  name: 'ClimbingGroupsDetailClients',
  components: { AppOptionPicker },
  props: {
    groupDetail: {
      type: Object
    }
  },
  data() {
    return {
      transfer: {
        ignore_client_group: false,
      },
      clients_options: [],
      table_clients_loading: false,
      filter_clients: true,
      table: {
        items: [],
        columns: [
          'count',
          'full_name',
          'group',
          'additional_services_orders.tent',
          'additional_services_orders.toilet',
          'additional_services_orders.shower',
          'phone',
          'porter',
          'water',
          'profile',
        ],
        options: {
          headings: {
            'select': '',
            'count': '#',
            'full_name': 'Full name',
            'reach_point': 'Reach point',
            'group': 'Group',
            'additional_services_orders.tent': 'Tent',
            'additional_services_orders.toilet': 'Toilet',
            'additional_services_orders.shower': 'Shower',
            'phone': 'Phone',
            'porter': 'Porter',
            'water': 'Water',
            'profile': 'Profile',
            'checklist': 'Checklist',
            'controls': '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 300,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      current_client: null,
      checked_all: false,
      checked: [],
      is_show_flying_block: false,
      groups_options: [],
      family_url: process.env.VUE_APP_FAMILY,
      checked_color: null,
      create_new_group: true,
      search: '',
      checked_color_filter: [],
      status_options: [],
      client_to_delete: null,
    }
  },
  validations: {
    transfer: {
      new_group: {
        required: requiredIf(function() {
          return !this.create_new_group
        })
      },
      group_name: {
        required: requiredIf(function() {
          return this.create_new_group
        })
      }
    }
  },
  watch: {
    checked_all(value) {
      if (value) {
        this.table.items.forEach(item => {
          if (!this.checked.includes(item.id)) this.checked.push(item.id)
        })
      } else {
        this.checked = []
      }
    },
    checked(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked.length) this.checked_all = false
    },
  },
  computed: {
    is_general() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_operation_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor')
    },
    is_climbing_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('climbing_supervisor')
    },
    is_climbing_assistant() {
      return this.$store.state.userGroups.map(item => item.code).includes('climbing_assistant')
    },
    is_climbing_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('climbing_manager')
    },
    show_select_checkboxes() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager') ||
        this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('climbing_supervisor') ||
        this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_supervisor')
    },
    is_operations_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_manager')
    },
    is_operations_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('operations_supervisor')
    },
  },
  created() {
    this.fetchItems()
    if (!this.groupDetail.route.accommodation_type) this.table.columns.splice(4, 1)
    else if (this.groupDetail.route.accommodation_type?.code === 'huts') this.table.options.headings['additional_services_orders.tent'] = 'Hut'
    if (this.show_select_checkboxes) {
      this.table.columns.unshift('select')
    }
    if (this.is_general || this.is_climbing_supervisor || this.is_climbing_assistant || this.is_climbing_manager) {
      this.table.columns.splice(4, 0, 'reach_point')
    }
    if (this.is_operation_supervisor || this.is_climbing_supervisor || this.is_general || this.is_sales_supervisor || this.is_sales_manager) {
      this.table.columns.push('controls')
    }
  },
  methods: {
    onOptionSelected(row) {
      this.table_clients_loading = true
      patchClimbingGroupClients(this.$route.params.id, row.id, { reach_point: row.reach_point ? row.reach_point.code : null })
        .finally(() => { this.table_clients_loading = false })
        .then(() => { this.fetchItems() })
    },
    onCopyInsuranceData(data, type) {
      const string = `${data[`${type}_insurance_company`]}\n${data[`${type}_insurance_number`]}\n${this.dateFormat(data[`${type}_insurance_coverage_start`])} - ${this.dateFormat(data[`${type}_insurance_coverage_end`])}\n${data[`${type}_insurance_emergency_phone`]}`
      this.copyToClipboard(string)
    },
    copyToClipboard(string) {
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    tooltipInsuranceContent(data, type) {
      if (!data[`${type}_insurance_company`]) return
      return `${data[`${type}_insurance_company`]}<br>${data[`${type}_insurance_number`]}<br>${this.dateFormat(data[`${type}_insurance_coverage_start`])} - ${this.dateFormat(data[`${type}_insurance_coverage_end`])}<br>${data[`${type}_insurance_emergency_phone`]}`
    },
    onChangeFilter() {
      this.search = ''
      this.fetchItems()
    },
    tooltipContent(data) {
      return `${data.climbing_insurance_company}<br>${data.climbing_insurance_number}<br>${this.dateFormat(data.climbing_insurance_coverage_start)} - ${this.dateFormat(data.climbing_insurance_coverage_end)}<br>${data.climbing_insurance_emergency_phone}`
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
    onDeleteButtonClick(client, id) {
      this.current_client = client
      this.client_to_delete = id
      this.$modal.show('delete')
    },
    deleteClient() {
      this.$refs.delete.preload = true
      deleteClientClimbingGroup(this.$route.params.id, this.client_to_delete)
        .then(() => {
          this.fetchItems()
          this.$emit('getClimbingInfo')
          this.$emit('refreshTabCounts')
          this.$modal.hide('delete')
          this.$notify({
            type: 'success',
            title: 'Client deleted',
          })
        })
        .catch(() => { this.$refs.delete.preload = false })
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    fetchItems() {
      getClimbingGroupsClients(this.$route.params.id, {search: this.search, only_visible: this.is_sales ? this.filter_clients : false})
        .then(res => { this.table.items = res.data })
    },
    onCheckTransferForm() {
      this.$v.transfer.$touch()
      if (this.$v.transfer.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendTransferForm()
      }
    },
    sendTransferForm() {
      this.$refs.submitTransfer.preload = true
      const data = {
        source_group: +this.$route.params.id,
        clients: this.checked,
        ignore_client_group: this.transfer.ignore_client_group
      }
      if (!this.create_new_group) data.new_group = this.transfer.new_group.id
      else data.group_name = this.transfer.group_name
      postClientTransfer(data)
        .finally(() => { this.$refs.submitTransfer.preload = false })
        .then(() => {
          this.fetchItems()
          this.$emit('getClimbingInfo')
          this.$emit('refreshTabCounts')
          this.checked = []
          this.$notify({
            type: 'success',
            title: 'Transfer completed',
          })
          this.$modal.hide('transfer-form')
        })
    },
    onGroupSearch(search, loading) {
      loading(true)
      this.searchGroup(loading, search, this)
    },
    searchGroup: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.groups_options = []
      } else {
        getClimbingGroups({search, category: 'upcoming'}).then(response => {
          vm.groups_options = response.data
          loading(false)
        })
      }
    }, 350),
    onShowTransferModal() {
      this.transfer = {
        ignore_client_group: false,
      }
      this.$v.transfer.$reset()
      this.$modal.show('transfer-form')
    },
    onExport(client_id) {
      getClimbingGroupChecklistExport(this.$route.params.id, client_id)
        .then(response => {
          window.open(response.data)
        })
    },
    onClientsSearch() {
      this.searchClients(this)
    },
    searchClients: debounce(vm => {
      vm.fetchItems()
    }, 350),
  }
}
</script>
